import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'CmgRetroCreditInfoCard',
})
export default class CmgRetroCreditInfoCard extends Vue {
  @Prop({ required: true, type: String })
  imageSrc!: string;
}
